{
  "nodes": [
    {
      "id": "Structural basis of PROTAC cooperative recognition for selective protein degradation.",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "The influence of rough lipopolysaccharide structure on molecular interactions with mammalian antimicrobial peptides",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "New Synthetic Routes to Triazolo-benzodiazepine Analogues: Expanding the Scope of the Bump-and-Hole Approach for Selective Bromo and Extra-Terminal (BET) Bromodomain Inhibition.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Cyclic and Macrocyclic Peptides as Chemical Tools To Recognise Protein Surfaces and Probe Protein-Protein Interactions.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Discovery of Type II Inhibitors of TGFβ-Activated Kinase 1 (TAK1) and Mitogen-Activated Protein Kinase Kinase Kinase Kinase 2 (MAP4K2)",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "SIK2 regulates CRTCs, HDAC4 and glucose uptake in adipocytes",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Metabotropic Glutamate Receptor 5 Negative Allosteric Modulators: Discovery of 2-Chloro-4-[1-(4-fluorophenyl)-2,5-dimethyl-1H-imidazol-4-ylethynyl]pyridine (Basimglurant, RO4917523), a Promising Novel Medicine for Psychiatric Diseases",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Nrf2 regulates ROS production by mitochondria and NADPH oxidase.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "The clinically approved drugs dasatinib and bosutinib induce anti-inflammatory macrophages by inhibiting the salt-inducible kinases",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "New Monocyclic, Bicyclic, and Tricyclic Ethynylcyanodienones as Activators of the Keap1/Nrf2/ARE Pathway and Inhibitors of Inducible Nitric Oxide Synthase",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Palmitoylation of the Na/Ca exchanger cytoplasmic loop controls its inactivation and internalization during stress signaling",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Molecular Cloning and Functional Characterization of Components of the Capsule Biosynthesis Complex of Neisseria meningitidis Serogroup A TOWARD IN VITRO VACCINE PRODUCTION",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "group": "Cited Works",
      "radius": 7,
      "citing_patents_count": 7
    },
    {
      "id": "An unexpected twist to the activation of IKKβ: TAK1 primes IKKβ for activation by autophosphorylation",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Crystallographic analysis of Neisseria meningitidis PorB extracellular loops potentially implicated in TLR2 recognition",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "The LKB1-salt-inducible kinase pathway functions as a key gluconeogenic suppressor in the liver",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-κB: potential candidates for chemoprevention.",
      "group": "Cited Works",
      "radius": 6,
      "citing_patents_count": 6
    },
    {
      "id": "Carnosic acid stimulates glucose uptake in skeletal muscle cells via a PME-1/PP2A/PKB signalling axis",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Kv1.3 inhibitors have differential effects on glucose uptake and AMPK activity in skeletal muscle cell lines and mouse ex vivo skeletal muscle",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Restoration of CFTR function in patients with cystic fibrosis carrying the F508del-CFTR mutation",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65",
      "group": "Cited Works",
      "radius": 4,
      "citing_patents_count": 4
    },
    {
      "id": "Substrate recognition by the cell surface palmitoyl transferase DHHC5.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Dysregulation of ubiquitin homeostasis and β-catenin signaling promote spinal muscular atrophy",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Structure-Guided Design and Optimization of Small Molecules Targeting the Protein–Protein Interaction between the von Hippel–Lindau (VHL) E3 Ubiquitin Ligase and the Hypoxia Inducible Factor (HIF) Alpha Subunit with in Vitro Nanomolar Affinities",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "The Nrf2 regulatory network provides an interface between redox and intermediary metabolism",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Characterization of WZ4003 and HTH-01-015 as selective inhibitors of the LKB1-tumour-suppressor-activated NUAK kinases",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples",
      "group": "Cited Works",
      "radius": 6,
      "citing_patents_count": 6
    },
    {
      "id": "Structure-activity relationship studies of pyrrolone antimalarial agents",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "The Concise Guide to Pharmacology 2013/14.: The Concise Guide to Pharmacology 2013/14: G Protein-Coupled Receptors",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Elevated SGK1 predicts resistance of breast cancer cells to Akt inhibitors",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Metabolism of inflammation limited by AMPK and pseudo-starvation",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Nrf2 impacts cellular bioenergetics by controlling substrate availability for mitochondrial respiration",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "The anti-inflammatory compound BAY 11-7082 is a potent inhibitor of Protein Tyrosine Phosphatases",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Investigation of acyclic uridine amide and 5′-amido nucleoside analogues as potential inhibitors of the Plasmodium falciparum dUTPase",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Discovery and structure-activity relationships of pyrrolone antimalarials",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Comprehensive characterization and optimization of anti-LRRK2 (leucine-rich repeat kinase 2) monoclonal antibodies",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "From On-Target to Off-Target Activity: Identification and Optimisation of Trypanosoma brucei GSK3 Inhibitors and Their Characterisation as Anti-Trypanosoma brucei Drug Discovery Lead Molecules",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "HIF-independent role of prolyl hydroxylases in the cellular response to amino acids",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "group": "Cited Works",
      "radius": 11,
      "citing_patents_count": 11
    },
    {
      "id": "A novel shogaol analog suppresses cancer cell invasion and inflammation, and displays cytoprotective effects through modulation of NF-κB and Nrf2-Keap1 signaling pathways",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "The endosome-lysosome pathway and information generation in the immune system.",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "GSK2578215A; a potent and highly selective 2-arylmethyloxy-5-substitutent-N-arylbenzamide LRRK2 kinase inhibitor.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Structure of the TatC core of the twin-arginine protein transport system",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "The Ancient Drug Salicylate Directly Activates AMP-Activated Protein Kinase",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Application of a novel highly sensitive activity-based probe for detection of cathepsin G",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Analysis of the role of Nrf2 in the expression of liver proteins in mice using two-dimensional gel-based proteomics",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Synthesis, Chemical Reactivity as Michael Acceptors, and Biological Potency of Monocyclic Cyanoenones, Novel and Highly Potent Anti-inflammatory and Cytoprotective Agents(1)",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors",
      "group": "Cited Works",
      "radius": 5,
      "citing_patents_count": 5
    },
    {
      "id": "Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Chemical Proteomic Analysis Reveals the Drugability of the Kinome of Trypanosoma brucei",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Avirulence Protein 3a (AVR3a) from the Potato Pathogen Phytophthora infestans Forms Homodimers through Its Predicted Translocation Region and Does Not Specifically Bind Phospholipids",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "NEDD8 overexpression results in neddylation of ubiquitin substrates by the ubiquitin pathway.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Kinome-wide Selectivity Profiling of ATP-competitive Mammalian Target of Rapamycin (mTOR) Inhibitors and Characterization of Their Binding Kinetics",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "The ubiquitin E1 enzyme Ube1 mediates NEDD8 activation under diverse stress conditions",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Acinetobacter baumannii FolD ligand complexes – potent inhibitors of folate metabolism and a re‐evaluation of the structure of LY374571",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Aurora kinase inhibitors: Progress towards the clinic",
      "group": "Cited Works",
      "radius": 12,
      "citing_patents_count": 12
    },
    {
      "id": "The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Synergy of Peptide and Sugar in O-GlcNAcase Substrate Recognition",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Discovery of potent and selective covalent inhibitors of JNK",
      "group": "Cited Works",
      "radius": 6,
      "citing_patents_count": 6
    },
    {
      "id": "Phosphorylation of FOXO3a on Ser-7 by p38 Promotes Its Nuclear Localization in Response to Doxorubicin",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "AMPK: a nutrient and energy sensor that maintains energy homeostasis",
      "group": "Cited Works",
      "radius": 6,
      "citing_patents_count": 6
    },
    {
      "id": "Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKKε kinases.",
      "group": "Cited Works",
      "radius": 4,
      "citing_patents_count": 4
    },
    {
      "id": "Peptide inhibitors of the Keap1-Nrf2 protein-protein interaction",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Small molecules that bind the Mdm2 RING stabilize and activate p53",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "group": "Cited Works",
      "radius": 29,
      "citing_patents_count": 29
    },
    {
      "id": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "group": "Cited Works",
      "radius": 11,
      "citing_patents_count": 11
    },
    {
      "id": "Changes in the ratio of free NEDD8 to ubiquitin triggers NEDDylation by ubiquitin enzymes",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.",
      "group": "Cited Works",
      "radius": 4,
      "citing_patents_count": 4
    },
    {
      "id": "A multifunctional protease inhibitor to regulate endolysosomal function.",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Design, Synthesis, and Structure−Activity Relationship Exploration of 1-Substituted 4-Aroyl-3-hydroxy-5-phenyl-1H-pyrrol-2(5H)-one Analogues as Inhibitors of the Annexin A2−S100A10 Protein Interaction",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "4-benzimidazolyl-3-phenylbutanoic acids as novel PIF-pocket-targeting allosteric inhibitors of protein kinase PKCζ.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors",
      "group": "Cited Works",
      "radius": 4,
      "citing_patents_count": 4
    },
    {
      "id": "Design, Synthesis and Biological Evaluation of Novel Inhibitors of Trypanosoma brucei Pteridine Reductase 1",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "The inhibitory effect of phospholemman on the sodium pump requires its palmitoylation.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "SCF/β-TrCP promotes glycogen synthase kinase 3-dependent degradation of the Nrf2 transcription factor in a keap1-independent manner",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Immunosuppressive but Non-LasR-Inducing Analogues of the Pseudomonas aeruginosa Quorum-Sensing Molecule N-(3-Oxododecanoyl)-L-homoserine Lactone",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Absolute SILAC-Compatible Expression Strain Allows Sumo-2 Copy Number Determination in Clinical Samples",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Collateral sensitivity of multidrug-resistant cells to the orphan drug tiopronin.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "group": "Cited Works",
      "radius": 11,
      "citing_patents_count": 11
    },
    {
      "id": "ATP site-directed inhibitors of protein kinase CK2: an update.",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Polyubiquitin binding to optineurin is required for optimal activation of TANK-binding kinase 1 and production of interferon β.",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.",
      "group": "Cited Works",
      "radius": 4,
      "citing_patents_count": 4
    },
    {
      "id": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "group": "Cited Works",
      "radius": 7,
      "citing_patents_count": 7
    },
    {
      "id": "Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Analgesic omega-Conotoxins CVIE and CVIF Selectively and Voltage-Dependently Block Recombinant and Native N-Type Calcium Channels (vol 77, pg 139, 2010)",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "NF-κB controls energy homeostasis and metabolic adaptation by upregulating mitochondrial respiration",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "Development of 18F-fluorinatable dendrons and their application to cancer cell targeting",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    {
      "id": "The specificities of small molecule inhibitors of the TGFß and BMP pathways",
      "group": "Cited Works",
      "radius": 3,
      "citing_patents_count": 3
    },
    {
      "id": "Catalysis by the nucleolytic ribozymes",
      "group": "Cited Works",
      "radius": 5,
      "citing_patents_count": 5
    },
    {
      "id": "Characterization of GSK2334470, a novel and highly specific inhibitor of PDK1",
      "group": "Cited Works",
      "radius": 2,
      "citing_patents_count": 2
    },
    {
      "id": "N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases",
      "group": "Cited Works",
      "radius": 4,
      "citing_patents_count": 4
    },
    {
      "id": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "group": "Cited Works",
      "radius": 7,
      "citing_patents_count": 7
    },
    {
      "id": "Optimisation of the Anti-Trypanosoma brucei Activity of the Opioid Agonist U50488",
      "group": "Cited Works",
      "radius": 1,
      "citing_patents_count": 1
    },
    { "id": "109-294-662-661-65X", "group": "Citing Patents" },
    { "id": "074-937-457-594-345", "group": "Citing Patents" },
    { "id": "081-355-367-506-27X", "group": "Citing Patents" },
    { "id": "048-634-530-447-798", "group": "Citing Patents" },
    { "id": "137-231-469-269-151", "group": "Citing Patents" },
    { "id": "031-072-815-607-16X", "group": "Citing Patents" },
    { "id": "105-312-070-982-098", "group": "Citing Patents" },
    { "id": "018-515-082-074-296", "group": "Citing Patents" },
    { "id": "027-228-373-793-594", "group": "Citing Patents" },
    { "id": "016-712-604-622-721", "group": "Citing Patents" },
    { "id": "086-316-087-480-933", "group": "Citing Patents" },
    { "id": "118-309-833-112-117", "group": "Citing Patents" },
    { "id": "134-672-819-080-83X", "group": "Citing Patents" },
    { "id": "036-789-224-520-054", "group": "Citing Patents" },
    { "id": "106-594-488-484-12X", "group": "Citing Patents" },
    { "id": "125-726-727-125-409", "group": "Citing Patents" },
    { "id": "161-487-188-181-03X", "group": "Citing Patents" },
    { "id": "076-538-237-089-675", "group": "Citing Patents" },
    { "id": "051-324-518-696-462", "group": "Citing Patents" },
    { "id": "198-017-973-913-570", "group": "Citing Patents" },
    { "id": "156-653-831-632-101", "group": "Citing Patents" },
    { "id": "178-739-712-688-618", "group": "Citing Patents" },
    { "id": "131-486-498-702-07X", "group": "Citing Patents" },
    { "id": "010-031-167-075-106", "group": "Citing Patents" },
    { "id": "119-453-428-180-987", "group": "Citing Patents" },
    { "id": "153-595-914-216-97X", "group": "Citing Patents" },
    { "id": "148-353-591-913-750", "group": "Citing Patents" },
    { "id": "019-827-938-996-490", "group": "Citing Patents" },
    { "id": "184-646-935-269-773", "group": "Citing Patents" },
    { "id": "186-230-275-872-748", "group": "Citing Patents" },
    { "id": "165-291-395-706-725", "group": "Citing Patents" },
    { "id": "047-113-007-956-15X", "group": "Citing Patents" },
    { "id": "089-019-916-582-397", "group": "Citing Patents" },
    { "id": "136-000-598-663-919", "group": "Citing Patents" },
    { "id": "051-072-189-723-758", "group": "Citing Patents" },
    { "id": "040-766-915-457-886", "group": "Citing Patents" },
    { "id": "141-482-415-400-338", "group": "Citing Patents" },
    { "id": "149-129-599-518-595", "group": "Citing Patents" },
    { "id": "156-286-485-464-499", "group": "Citing Patents" },
    { "id": "001-353-214-346-040", "group": "Citing Patents" },
    { "id": "118-479-143-842-720", "group": "Citing Patents" },
    { "id": "007-641-959-106-118", "group": "Citing Patents" },
    { "id": "189-040-066-278-226", "group": "Citing Patents" },
    { "id": "026-244-336-682-442", "group": "Citing Patents" },
    { "id": "168-286-254-597-740", "group": "Citing Patents" },
    { "id": "109-916-358-959-05X", "group": "Citing Patents" },
    { "id": "002-458-268-309-533", "group": "Citing Patents" },
    { "id": "038-310-729-099-192", "group": "Citing Patents" },
    { "id": "179-033-965-606-598", "group": "Citing Patents" },
    { "id": "113-229-447-433-64X", "group": "Citing Patents" },
    { "id": "077-771-399-719-227", "group": "Citing Patents" },
    { "id": "183-966-651-664-305", "group": "Citing Patents" },
    { "id": "013-467-292-050-692", "group": "Citing Patents" },
    { "id": "079-314-054-163-947", "group": "Citing Patents" },
    { "id": "110-082-309-221-187", "group": "Citing Patents" },
    { "id": "128-382-566-327-896", "group": "Citing Patents" },
    { "id": "143-543-676-408-839", "group": "Citing Patents" },
    { "id": "005-743-260-244-802", "group": "Citing Patents" },
    { "id": "026-638-223-054-804", "group": "Citing Patents" },
    { "id": "048-208-660-423-215", "group": "Citing Patents" },
    { "id": "159-658-602-048-982", "group": "Citing Patents" },
    { "id": "077-811-145-153-079", "group": "Citing Patents" },
    { "id": "170-781-236-728-970", "group": "Citing Patents" },
    { "id": "144-284-594-583-951", "group": "Citing Patents" },
    { "id": "139-409-891-293-77X", "group": "Citing Patents" },
    { "id": "081-017-751-048-013", "group": "Citing Patents" },
    { "id": "114-963-910-586-828", "group": "Citing Patents" },
    { "id": "162-513-842-046-362", "group": "Citing Patents" },
    { "id": "188-803-921-043-695", "group": "Citing Patents" },
    { "id": "191-147-881-232-285", "group": "Citing Patents" },
    { "id": "081-817-015-173-962", "group": "Citing Patents" },
    { "id": "106-530-060-683-82X", "group": "Citing Patents" },
    { "id": "133-935-409-400-672", "group": "Citing Patents" },
    { "id": "046-588-899-387-353", "group": "Citing Patents" },
    { "id": "049-222-171-973-678", "group": "Citing Patents" },
    { "id": "074-598-665-914-143", "group": "Citing Patents" },
    { "id": "190-195-697-065-907", "group": "Citing Patents" },
    { "id": "031-461-589-086-771", "group": "Citing Patents" },
    { "id": "167-851-091-520-257", "group": "Citing Patents" },
    { "id": "151-760-923-304-502", "group": "Citing Patents" },
    { "id": "097-019-537-894-104", "group": "Citing Patents" },
    { "id": "170-696-774-214-700", "group": "Citing Patents" },
    { "id": "084-807-525-209-072", "group": "Citing Patents" },
    { "id": "044-648-704-787-12X", "group": "Citing Patents" },
    { "id": "150-822-190-827-131", "group": "Citing Patents" },
    { "id": "051-919-508-851-10X", "group": "Citing Patents" },
    { "id": "036-251-116-198-69X", "group": "Citing Patents" },
    { "id": "149-946-446-737-586", "group": "Citing Patents" },
    { "id": "075-397-286-033-085", "group": "Citing Patents" },
    { "id": "028-992-308-265-357", "group": "Citing Patents" },
    { "id": "044-207-676-689-405", "group": "Citing Patents" },
    { "id": "030-350-713-791-200", "group": "Citing Patents" },
    { "id": "093-997-239-092-949", "group": "Citing Patents" },
    { "id": "046-345-437-716-689", "group": "Citing Patents" },
    { "id": "146-411-731-640-871", "group": "Citing Patents" },
    { "id": "000-266-572-036-366", "group": "Citing Patents" },
    { "id": "186-389-876-954-313", "group": "Citing Patents" },
    { "id": "168-483-508-794-377", "group": "Citing Patents" },
    { "id": "029-748-240-628-036", "group": "Citing Patents" },
    { "id": "184-507-509-452-559", "group": "Citing Patents" },
    { "id": "069-961-069-943-549", "group": "Citing Patents" },
    { "id": "017-777-392-752-199", "group": "Citing Patents" },
    { "id": "000-150-893-948-804", "group": "Citing Patents" },
    { "id": "027-437-502-794-894", "group": "Citing Patents" },
    { "id": "074-789-039-135-70X", "group": "Citing Patents" },
    { "id": "063-617-165-524-327", "group": "Citing Patents" },
    { "id": "019-872-586-012-269", "group": "Citing Patents" },
    { "id": "103-648-347-913-447", "group": "Citing Patents" },
    { "id": "007-245-406-573-328", "group": "Citing Patents" },
    { "id": "008-337-248-044-723", "group": "Citing Patents" },
    { "id": "197-071-041-313-103", "group": "Citing Patents" },
    { "id": "098-538-513-984-747", "group": "Citing Patents" },
    { "id": "019-125-805-246-964", "group": "Citing Patents" },
    { "id": "172-064-016-145-117", "group": "Citing Patents" },
    { "id": "007-417-942-335-284", "group": "Citing Patents" },
    { "id": "005-947-025-410-764", "group": "Citing Patents" },
    { "id": "116-404-026-640-450", "group": "Citing Patents" },
    { "id": "090-437-295-781-023", "group": "Citing Patents" },
    { "id": "197-158-559-918-854", "group": "Citing Patents" },
    { "id": "076-225-263-850-117", "group": "Citing Patents" },
    { "id": "049-199-509-181-561", "group": "Citing Patents" },
    { "id": "179-045-041-176-506", "group": "Citing Patents" },
    { "id": "004-301-778-674-378", "group": "Citing Patents" },
    { "id": "111-313-231-732-367", "group": "Citing Patents" },
    { "id": "092-197-031-561-353", "group": "Citing Patents" },
    { "id": "192-019-786-423-841", "group": "Citing Patents" },
    { "id": "076-608-180-638-59X", "group": "Citing Patents" },
    { "id": "175-263-797-963-040", "group": "Citing Patents" },
    { "id": "141-694-167-791-759", "group": "Citing Patents" },
    { "id": "081-203-444-563-604", "group": "Citing Patents" },
    { "id": "125-348-249-762-351", "group": "Citing Patents" },
    { "id": "125-850-986-196-787", "group": "Citing Patents" },
    { "id": "119-397-162-706-860", "group": "Citing Patents" },
    { "id": "133-023-408-974-285", "group": "Citing Patents" },
    { "id": "039-847-299-166-952", "group": "Citing Patents" },
    { "id": "076-641-402-312-988", "group": "Citing Patents" },
    { "id": "102-485-198-725-150", "group": "Citing Patents" },
    { "id": "168-829-456-947-639", "group": "Citing Patents" },
    { "id": "098-813-369-162-741", "group": "Citing Patents" },
    { "id": "023-180-369-416-862", "group": "Citing Patents" },
    { "id": "189-473-046-734-005", "group": "Citing Patents" },
    { "id": "019-633-684-883-828", "group": "Citing Patents" },
    { "id": "174-501-376-407-235", "group": "Citing Patents" },
    { "id": "129-062-448-949-030", "group": "Citing Patents" },
    { "id": "162-916-741-322-002", "group": "Citing Patents" },
    { "id": "080-026-305-809-343", "group": "Citing Patents" },
    { "id": "016-698-167-713-829", "group": "Citing Patents" },
    { "id": "091-325-080-234-401", "group": "Citing Patents" },
    { "id": "032-206-614-235-635", "group": "Citing Patents" },
    { "id": "143-271-017-351-983", "group": "Citing Patents" },
    { "id": "169-312-245-869-778", "group": "Citing Patents" },
    { "id": "089-818-979-077-305", "group": "Citing Patents" },
    { "id": "187-517-157-601-239", "group": "Citing Patents" },
    { "id": "111-583-988-147-450", "group": "Citing Patents" },
    { "id": "058-026-435-099-506", "group": "Citing Patents" },
    { "id": "153-651-762-444-327", "group": "Citing Patents" },
    { "id": "159-766-711-047-610", "group": "Citing Patents" },
    { "id": "058-933-099-316-100", "group": "Citing Patents" },
    { "id": "023-452-662-674-373", "group": "Citing Patents" },
    { "id": "047-432-030-246-04X", "group": "Citing Patents" },
    { "id": "139-008-712-602-518", "group": "Citing Patents" },
    { "id": "137-720-748-139-162", "group": "Citing Patents" },
    { "id": "192-136-893-476-749", "group": "Citing Patents" },
    { "id": "172-890-893-515-719", "group": "Citing Patents" },
    { "id": "104-472-615-006-481", "group": "Citing Patents" },
    { "id": "097-374-332-908-898", "group": "Citing Patents" },
    { "id": "034-416-075-094-770", "group": "Citing Patents" },
    { "id": "127-642-274-375-054", "group": "Citing Patents" },
    { "id": "036-708-909-192-156", "group": "Citing Patents" },
    { "id": "193-863-590-855-263", "group": "Citing Patents" },
    { "id": "150-028-859-997-047", "group": "Citing Patents" },
    { "id": "132-394-716-226-832", "group": "Citing Patents" },
    { "id": "131-238-819-455-784", "group": "Citing Patents" },
    { "id": "155-402-461-387-483", "group": "Citing Patents" },
    { "id": "040-389-070-176-191", "group": "Citing Patents" },
    { "id": "076-478-479-475-120", "group": "Citing Patents" },
    { "id": "034-190-802-321-708", "group": "Citing Patents" },
    { "id": "130-316-719-983-242", "group": "Citing Patents" },
    { "id": "036-668-261-470-040", "group": "Citing Patents" },
    { "id": "183-767-289-461-131", "group": "Citing Patents" },
    { "id": "107-556-164-321-147", "group": "Citing Patents" },
    { "id": "066-190-726-252-149", "group": "Citing Patents" },
    { "id": "140-900-012-438-14X", "group": "Citing Patents" },
    { "id": "058-438-690-312-096", "group": "Citing Patents" },
    { "id": "004-889-112-130-518", "group": "Citing Patents" },
    { "id": "193-040-307-473-220", "group": "Citing Patents" },
    { "id": "188-718-220-131-362", "group": "Citing Patents" },
    { "id": "087-577-350-425-176", "group": "Citing Patents" },
    { "id": "191-670-060-004-126", "group": "Citing Patents" },
    { "id": "041-699-843-843-567", "group": "Citing Patents" },
    { "id": "180-366-233-781-99X", "group": "Citing Patents" },
    { "id": "122-739-962-072-793", "group": "Citing Patents" },
    { "id": "109-274-898-147-341", "group": "Citing Patents" },
    { "id": "124-179-501-005-870", "group": "Citing Patents" },
    { "id": "008-694-981-426-172", "group": "Citing Patents" },
    { "id": "109-611-546-954-080", "group": "Citing Patents" },
    { "id": "004-378-254-734-355", "group": "Citing Patents" },
    { "id": "133-997-520-845-569", "group": "Citing Patents" },
    { "id": "115-381-943-359-61X", "group": "Citing Patents" },
    { "id": "022-078-711-389-998", "group": "Citing Patents" },
    { "id": "132-854-391-972-865", "group": "Citing Patents" },
    { "id": "171-143-110-884-468", "group": "Citing Patents" },
    { "id": "003-946-199-636-328", "group": "Citing Patents" },
    { "id": "009-649-401-227-606", "group": "Citing Patents" },
    { "id": "170-042-571-881-121", "group": "Citing Patents" },
    { "id": "033-301-273-471-462", "group": "Citing Patents" },
    { "id": "040-826-560-477-838", "group": "Citing Patents" },
    { "id": "135-293-472-746-415", "group": "Citing Patents" },
    { "id": "153-999-081-812-523", "group": "Citing Patents" },
    { "id": "000-498-778-953-787", "group": "Citing Patents" },
    { "id": "085-065-777-135-758", "group": "Citing Patents" },
    { "id": "152-366-692-522-975", "group": "Citing Patents" },
    { "id": "167-869-142-610-582", "group": "Citing Patents" },
    { "id": "191-676-336-200-724", "group": "Citing Patents" },
    { "id": "056-387-403-639-935", "group": "Citing Patents" },
    { "id": "066-841-401-628-941", "group": "Citing Patents" },
    { "id": "069-503-782-573-055", "group": "Citing Patents" },
    { "id": "028-137-796-142-577", "group": "Citing Patents" },
    { "id": "197-678-301-596-236", "group": "Citing Patents" },
    { "id": "147-466-934-435-143", "group": "Citing Patents" },
    { "id": "114-647-123-099-321", "group": "Citing Patents" },
    { "id": "058-829-130-504-901", "group": "Citing Patents" },
    { "id": "169-953-034-717-264", "group": "Citing Patents" },
    { "id": "028-012-588-449-727", "group": "Citing Patents" },
    { "id": "038-839-140-589-623", "group": "Citing Patents" },
    { "id": "194-924-906-201-593", "group": "Citing Patents" },
    { "id": "195-611-964-620-410", "group": "Citing Patents" },
    { "id": "025-014-524-538-421", "group": "Citing Patents" },
    { "id": "120-667-268-642-909", "group": "Citing Patents" },
    { "id": "163-117-320-460-138", "group": "Citing Patents" },
    { "id": "191-290-593-697-506", "group": "Citing Patents" },
    { "id": "118-339-847-530-982", "group": "Citing Patents" },
    { "id": "073-318-370-112-877", "group": "Citing Patents" },
    { "id": "113-828-920-381-078", "group": "Citing Patents" },
    { "id": "048-983-957-537-421", "group": "Citing Patents" },
    { "id": "073-531-962-083-670", "group": "Citing Patents" }
  ],
  "links": [
    {
      "source": "Structural basis of PROTAC cooperative recognition for selective protein degradation.",
      "target": "109-294-662-661-65X",
      "value": 2
    },
    {
      "source": "Structural basis of PROTAC cooperative recognition for selective protein degradation.",
      "target": "074-937-457-594-345",
      "value": 2
    },
    {
      "source": "The influence of rough lipopolysaccharide structure on molecular interactions with mammalian antimicrobial peptides",
      "target": "081-355-367-506-27X",
      "value": 2
    },
    {
      "source": "New Synthetic Routes to Triazolo-benzodiazepine Analogues: Expanding the Scope of the Bump-and-Hole Approach for Selective Bromo and Extra-Terminal (BET) Bromodomain Inhibition.",
      "target": "048-634-530-447-798",
      "value": 2
    },
    {
      "source": "Cyclic and Macrocyclic Peptides as Chemical Tools To Recognise Protein Surfaces and Probe Protein-Protein Interactions.",
      "target": "137-231-469-269-151",
      "value": 2
    },
    {
      "source": "8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.",
      "target": "031-072-815-607-16X",
      "value": 2
    },
    {
      "source": "8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.",
      "target": "105-312-070-982-098",
      "value": 2
    },
    {
      "source": "8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.",
      "target": "018-515-082-074-296",
      "value": 2
    },
    {
      "source": "Discovery of Type II Inhibitors of TGFβ-Activated Kinase 1 (TAK1) and Mitogen-Activated Protein Kinase Kinase Kinase Kinase 2 (MAP4K2)",
      "target": "027-228-373-793-594",
      "value": 2
    },
    {
      "source": "SIK2 regulates CRTCs, HDAC4 and glucose uptake in adipocytes",
      "target": "016-712-604-622-721",
      "value": 2
    },
    {
      "source": "Metabotropic Glutamate Receptor 5 Negative Allosteric Modulators: Discovery of 2-Chloro-4-[1-(4-fluorophenyl)-2,5-dimethyl-1H-imidazol-4-ylethynyl]pyridine (Basimglurant, RO4917523), a Promising Novel Medicine for Psychiatric Diseases",
      "target": "086-316-087-480-933",
      "value": 2
    },
    {
      "source": "Nrf2 regulates ROS production by mitochondria and NADPH oxidase.",
      "target": "118-309-833-112-117",
      "value": 2
    },
    {
      "source": "The clinically approved drugs dasatinib and bosutinib induce anti-inflammatory macrophages by inhibiting the salt-inducible kinases",
      "target": "134-672-819-080-83X",
      "value": 2
    },
    {
      "source": "New Monocyclic, Bicyclic, and Tricyclic Ethynylcyanodienones as Activators of the Keap1/Nrf2/ARE Pathway and Inhibitors of Inducible Nitric Oxide Synthase",
      "target": "036-789-224-520-054",
      "value": 2
    },
    {
      "source": "Palmitoylation of the Na/Ca exchanger cytoplasmic loop controls its inactivation and internalization during stress signaling",
      "target": "106-594-488-484-12X",
      "value": 2
    },
    {
      "source": "Molecular Cloning and Functional Characterization of Components of the Capsule Biosynthesis Complex of Neisseria meningitidis Serogroup A TOWARD IN VITRO VACCINE PRODUCTION",
      "target": "125-726-727-125-409",
      "value": 2
    },
    {
      "source": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "target": "161-487-188-181-03X",
      "value": 2
    },
    {
      "source": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "target": "076-538-237-089-675",
      "value": 2
    },
    {
      "source": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "target": "051-324-518-696-462",
      "value": 2
    },
    {
      "source": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "target": "198-017-973-913-570",
      "value": 2
    },
    {
      "source": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "target": "156-653-831-632-101",
      "value": 2
    },
    {
      "source": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "target": "178-739-712-688-618",
      "value": 2
    },
    {
      "source": "A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes",
      "target": "048-634-530-447-798",
      "value": 2
    },
    {
      "source": "An unexpected twist to the activation of IKKβ: TAK1 primes IKKβ for activation by autophosphorylation",
      "target": "131-486-498-702-07X",
      "value": 2
    },
    {
      "source": "An unexpected twist to the activation of IKKβ: TAK1 primes IKKβ for activation by autophosphorylation",
      "target": "010-031-167-075-106",
      "value": 2
    },
    {
      "source": "Crystallographic analysis of Neisseria meningitidis PorB extracellular loops potentially implicated in TLR2 recognition",
      "target": "119-453-428-180-987",
      "value": 2
    },
    {
      "source": "The LKB1-salt-inducible kinase pathway functions as a key gluconeogenic suppressor in the liver",
      "target": "016-712-604-622-721",
      "value": 2
    },
    {
      "source": "Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase",
      "target": "153-595-914-216-97X",
      "value": 2
    },
    {
      "source": "Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase",
      "target": "148-353-591-913-750",
      "value": 2
    },
    {
      "source": "Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase",
      "target": "019-827-938-996-490",
      "value": 2
    },
    {
      "source": "3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-κB: potential candidates for chemoprevention.",
      "target": "184-646-935-269-773",
      "value": 2
    },
    {
      "source": "3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-κB: potential candidates for chemoprevention.",
      "target": "186-230-275-872-748",
      "value": 2
    },
    {
      "source": "3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-κB: potential candidates for chemoprevention.",
      "target": "165-291-395-706-725",
      "value": 2
    },
    {
      "source": "3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-κB: potential candidates for chemoprevention.",
      "target": "047-113-007-956-15X",
      "value": 2
    },
    {
      "source": "3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-κB: potential candidates for chemoprevention.",
      "target": "089-019-916-582-397",
      "value": 2
    },
    {
      "source": "3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-κB: potential candidates for chemoprevention.",
      "target": "136-000-598-663-919",
      "value": 2
    },
    {
      "source": "Carnosic acid stimulates glucose uptake in skeletal muscle cells via a PME-1/PP2A/PKB signalling axis",
      "target": "051-072-189-723-758",
      "value": 2
    },
    {
      "source": "Kv1.3 inhibitors have differential effects on glucose uptake and AMPK activity in skeletal muscle cell lines and mouse ex vivo skeletal muscle",
      "target": "040-766-915-457-886",
      "value": 2
    },
    {
      "source": "Kv1.3 inhibitors have differential effects on glucose uptake and AMPK activity in skeletal muscle cell lines and mouse ex vivo skeletal muscle",
      "target": "141-482-415-400-338",
      "value": 2
    },
    {
      "source": "Restoration of CFTR function in patients with cystic fibrosis carrying the F508del-CFTR mutation",
      "target": "149-129-599-518-595",
      "value": 2
    },
    {
      "source": "Restoration of CFTR function in patients with cystic fibrosis carrying the F508del-CFTR mutation",
      "target": "156-286-485-464-499",
      "value": 2
    },
    {
      "source": "Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65",
      "target": "001-353-214-346-040",
      "value": 2
    },
    {
      "source": "Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65",
      "target": "118-479-143-842-720",
      "value": 2
    },
    {
      "source": "Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65",
      "target": "007-641-959-106-118",
      "value": 2
    },
    {
      "source": "Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65",
      "target": "189-040-066-278-226",
      "value": 2
    },
    {
      "source": "Substrate recognition by the cell surface palmitoyl transferase DHHC5.",
      "target": "106-594-488-484-12X",
      "value": 2
    },
    {
      "source": "Dysregulation of ubiquitin homeostasis and β-catenin signaling promote spinal muscular atrophy",
      "target": "026-244-336-682-442",
      "value": 2
    },
    {
      "source": "Structure-Guided Design and Optimization of Small Molecules Targeting the Protein–Protein Interaction between the von Hippel–Lindau (VHL) E3 Ubiquitin Ligase and the Hypoxia Inducible Factor (HIF) Alpha Subunit with in Vitro Nanomolar Affinities",
      "target": "074-937-457-594-345",
      "value": 2
    },
    {
      "source": "Structure-Guided Design and Optimization of Small Molecules Targeting the Protein–Protein Interaction between the von Hippel–Lindau (VHL) E3 Ubiquitin Ligase and the Hypoxia Inducible Factor (HIF) Alpha Subunit with in Vitro Nanomolar Affinities",
      "target": "168-286-254-597-740",
      "value": 2
    },
    {
      "source": "The Nrf2 regulatory network provides an interface between redox and intermediary metabolism",
      "target": "109-916-358-959-05X",
      "value": 2
    },
    {
      "source": "Characterization of WZ4003 and HTH-01-015 as selective inhibitors of the LKB1-tumour-suppressor-activated NUAK kinases",
      "target": "002-458-268-309-533",
      "value": 2
    },
    {
      "source": "Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples",
      "target": "038-310-729-099-192",
      "value": 2
    },
    {
      "source": "Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples",
      "target": "179-033-965-606-598",
      "value": 2
    },
    {
      "source": "Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples",
      "target": "113-229-447-433-64X",
      "value": 2
    },
    {
      "source": "Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples",
      "target": "077-771-399-719-227",
      "value": 2
    },
    {
      "source": "Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples",
      "target": "183-966-651-664-305",
      "value": 2
    },
    {
      "source": "Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples",
      "target": "013-467-292-050-692",
      "value": 2
    },
    {
      "source": "Structure-activity relationship studies of pyrrolone antimalarial agents",
      "target": "079-314-054-163-947",
      "value": 2
    },
    {
      "source": "Structure-activity relationship studies of pyrrolone antimalarial agents",
      "target": "110-082-309-221-187",
      "value": 2
    },
    {
      "source": "The Concise Guide to Pharmacology 2013/14.: The Concise Guide to Pharmacology 2013/14: G Protein-Coupled Receptors",
      "target": "128-382-566-327-896",
      "value": 2
    },
    {
      "source": "The Concise Guide to Pharmacology 2013/14.: The Concise Guide to Pharmacology 2013/14: G Protein-Coupled Receptors",
      "target": "143-543-676-408-839",
      "value": 2
    },
    {
      "source": "Elevated SGK1 predicts resistance of breast cancer cells to Akt inhibitors",
      "target": "005-743-260-244-802",
      "value": 2
    },
    {
      "source": "Metabolism of inflammation limited by AMPK and pseudo-starvation",
      "target": "026-638-223-054-804",
      "value": 2
    },
    {
      "source": "Nrf2 impacts cellular bioenergetics by controlling substrate availability for mitochondrial respiration",
      "target": "048-208-660-423-215",
      "value": 2
    },
    {
      "source": "The anti-inflammatory compound BAY 11-7082 is a potent inhibitor of Protein Tyrosine Phosphatases",
      "target": "159-658-602-048-982",
      "value": 2
    },
    {
      "source": "BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm",
      "target": "077-811-145-153-079",
      "value": 2
    },
    {
      "source": "BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm",
      "target": "170-781-236-728-970",
      "value": 2
    },
    {
      "source": "BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm",
      "target": "144-284-594-583-951",
      "value": 2
    },
    {
      "source": "Investigation of acyclic uridine amide and 5′-amido nucleoside analogues as potential inhibitors of the Plasmodium falciparum dUTPase",
      "target": "139-409-891-293-77X",
      "value": 2
    },
    {
      "source": "Discovery and structure-activity relationships of pyrrolone antimalarials",
      "target": "110-082-309-221-187",
      "value": 2
    },
    {
      "source": "De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments",
      "target": "081-017-751-048-013",
      "value": 2
    },
    {
      "source": "De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments",
      "target": "114-963-910-586-828",
      "value": 2
    },
    {
      "source": "De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments",
      "target": "162-513-842-046-362",
      "value": 2
    },
    {
      "source": "Comprehensive characterization and optimization of anti-LRRK2 (leucine-rich repeat kinase 2) monoclonal antibodies",
      "target": "188-803-921-043-695",
      "value": 2
    },
    {
      "source": "From On-Target to Off-Target Activity: Identification and Optimisation of Trypanosoma brucei GSK3 Inhibitors and Their Characterisation as Anti-Trypanosoma brucei Drug Discovery Lead Molecules",
      "target": "191-147-881-232-285",
      "value": 2
    },
    {
      "source": "From On-Target to Off-Target Activity: Identification and Optimisation of Trypanosoma brucei GSK3 Inhibitors and Their Characterisation as Anti-Trypanosoma brucei Drug Discovery Lead Molecules",
      "target": "081-817-015-173-962",
      "value": 2
    },
    {
      "source": "HIF-independent role of prolyl hydroxylases in the cellular response to amino acids",
      "target": "106-530-060-683-82X",
      "value": 2
    },
    {
      "source": "HIF-independent role of prolyl hydroxylases in the cellular response to amino acids",
      "target": "133-935-409-400-672",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "046-588-899-387-353",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "051-324-518-696-462",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "161-487-188-181-03X",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "156-653-831-632-101",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "198-017-973-913-570",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "076-538-237-089-675",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "198-017-973-913-570",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "076-538-237-089-675",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "051-324-518-696-462",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "161-487-188-181-03X",
      "value": 2
    },
    {
      "source": "Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones",
      "target": "156-653-831-632-101",
      "value": 2
    },
    {
      "source": "A novel shogaol analog suppresses cancer cell invasion and inflammation, and displays cytoprotective effects through modulation of NF-κB and Nrf2-Keap1 signaling pathways",
      "target": "049-222-171-973-678",
      "value": 2
    },
    {
      "source": "A novel shogaol analog suppresses cancer cell invasion and inflammation, and displays cytoprotective effects through modulation of NF-κB and Nrf2-Keap1 signaling pathways",
      "target": "074-598-665-914-143",
      "value": 2
    },
    {
      "source": "X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor",
      "target": "161-487-188-181-03X",
      "value": 2
    },
    {
      "source": "X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor",
      "target": "156-653-831-632-101",
      "value": 2
    },
    {
      "source": "X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor",
      "target": "051-324-518-696-462",
      "value": 2
    },
    {
      "source": "The endosome-lysosome pathway and information generation in the immune system.",
      "target": "190-195-697-065-907",
      "value": 2
    },
    {
      "source": "The endosome-lysosome pathway and information generation in the immune system.",
      "target": "031-461-589-086-771",
      "value": 2
    },
    {
      "source": "GSK2578215A; a potent and highly selective 2-arylmethyloxy-5-substitutent-N-arylbenzamide LRRK2 kinase inhibitor.",
      "target": "167-851-091-520-257",
      "value": 2
    },
    {
      "source": "Structure of the TatC core of the twin-arginine protein transport system",
      "target": "151-760-923-304-502",
      "value": 2
    },
    {
      "source": "The Ancient Drug Salicylate Directly Activates AMP-Activated Protein Kinase",
      "target": "097-019-537-894-104",
      "value": 2
    },
    {
      "source": "The Ancient Drug Salicylate Directly Activates AMP-Activated Protein Kinase",
      "target": "170-696-774-214-700",
      "value": 2
    },
    {
      "source": "Application of a novel highly sensitive activity-based probe for detection of cathepsin G",
      "target": "084-807-525-209-072",
      "value": 2
    },
    {
      "source": "Analysis of the role of Nrf2 in the expression of liver proteins in mice using two-dimensional gel-based proteomics",
      "target": "044-648-704-787-12X",
      "value": 2
    },
    {
      "source": "PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65",
      "target": "001-353-214-346-040",
      "value": 2
    },
    {
      "source": "PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65",
      "target": "150-822-190-827-131",
      "value": 2
    },
    {
      "source": "PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65",
      "target": "051-919-508-851-10X",
      "value": 2
    },
    {
      "source": "Synthesis, Chemical Reactivity as Michael Acceptors, and Biological Potency of Monocyclic Cyanoenones, Novel and Highly Potent Anti-inflammatory and Cytoprotective Agents(1)",
      "target": "036-789-224-520-054",
      "value": 2
    },
    {
      "source": "Synthesis, Chemical Reactivity as Michael Acceptors, and Biological Potency of Monocyclic Cyanoenones, Novel and Highly Potent Anti-inflammatory and Cytoprotective Agents(1)",
      "target": "036-251-116-198-69X",
      "value": 2
    },
    {
      "source": "Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors",
      "target": "149-946-446-737-586",
      "value": 2
    },
    {
      "source": "Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors",
      "target": "075-397-286-033-085",
      "value": 2
    },
    {
      "source": "Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors",
      "target": "028-992-308-265-357",
      "value": 2
    },
    {
      "source": "Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors",
      "target": "044-207-676-689-405",
      "value": 2
    },
    {
      "source": "Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors",
      "target": "030-350-713-791-200",
      "value": 2
    },
    {
      "source": "Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.",
      "target": "093-997-239-092-949",
      "value": 2
    },
    {
      "source": "Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.",
      "target": "046-345-437-716-689",
      "value": 2
    },
    {
      "source": "Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.",
      "target": "146-411-731-640-871",
      "value": 2
    },
    {
      "source": "Chemical Proteomic Analysis Reveals the Drugability of the Kinome of Trypanosoma brucei",
      "target": "000-266-572-036-366",
      "value": 2
    },
    {
      "source": "Avirulence Protein 3a (AVR3a) from the Potato Pathogen Phytophthora infestans Forms Homodimers through Its Predicted Translocation Region and Does Not Specifically Bind Phospholipids",
      "target": "186-389-876-954-313",
      "value": 2
    },
    {
      "source": "NEDD8 overexpression results in neddylation of ubiquitin substrates by the ubiquitin pathway.",
      "target": "168-483-508-794-377",
      "value": 2
    },
    {
      "source": "Kinome-wide Selectivity Profiling of ATP-competitive Mammalian Target of Rapamycin (mTOR) Inhibitors and Characterization of Their Binding Kinetics",
      "target": "029-748-240-628-036",
      "value": 2
    },
    {
      "source": "The ubiquitin E1 enzyme Ube1 mediates NEDD8 activation under diverse stress conditions",
      "target": "184-507-509-452-559",
      "value": 2
    },
    {
      "source": "Acinetobacter baumannii FolD ligand complexes – potent inhibitors of folate metabolism and a re‐evaluation of the structure of LY374571",
      "target": "069-961-069-943-549",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "017-777-392-752-199",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "000-150-893-948-804",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "027-437-502-794-894",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "074-789-039-135-70X",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "063-617-165-524-327",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "019-872-586-012-269",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "103-648-347-913-447",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "007-245-406-573-328",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "027-437-502-794-894",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "008-337-248-044-723",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "197-071-041-313-103",
      "value": 2
    },
    {
      "source": "Aurora kinase inhibitors: Progress towards the clinic",
      "target": "098-538-513-984-747",
      "value": 2
    },
    {
      "source": "The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes",
      "target": "019-125-805-246-964",
      "value": 2
    },
    {
      "source": "The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes",
      "target": "172-064-016-145-117",
      "value": 2
    },
    {
      "source": "The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes",
      "target": "007-417-942-335-284",
      "value": 2
    },
    {
      "source": "Synergy of Peptide and Sugar in O-GlcNAcase Substrate Recognition",
      "target": "005-947-025-410-764",
      "value": 2
    },
    {
      "source": "Synergy of Peptide and Sugar in O-GlcNAcase Substrate Recognition",
      "target": "116-404-026-640-450",
      "value": 2
    },
    {
      "source": "Discovery of potent and selective covalent inhibitors of JNK",
      "target": "090-437-295-781-023",
      "value": 2
    },
    {
      "source": "Discovery of potent and selective covalent inhibitors of JNK",
      "target": "197-158-559-918-854",
      "value": 2
    },
    {
      "source": "Discovery of potent and selective covalent inhibitors of JNK",
      "target": "076-225-263-850-117",
      "value": 2
    },
    {
      "source": "Discovery of potent and selective covalent inhibitors of JNK",
      "target": "049-199-509-181-561",
      "value": 2
    },
    {
      "source": "Discovery of potent and selective covalent inhibitors of JNK",
      "target": "179-045-041-176-506",
      "value": 2
    },
    {
      "source": "Discovery of potent and selective covalent inhibitors of JNK",
      "target": "004-301-778-674-378",
      "value": 2
    },
    {
      "source": "Phosphorylation of FOXO3a on Ser-7 by p38 Promotes Its Nuclear Localization in Response to Doxorubicin",
      "target": "111-313-231-732-367",
      "value": 2
    },
    {
      "source": "AMPK: a nutrient and energy sensor that maintains energy homeostasis",
      "target": "092-197-031-561-353",
      "value": 2
    },
    {
      "source": "AMPK: a nutrient and energy sensor that maintains energy homeostasis",
      "target": "192-019-786-423-841",
      "value": 2
    },
    {
      "source": "AMPK: a nutrient and energy sensor that maintains energy homeostasis",
      "target": "192-019-786-423-841",
      "value": 2
    },
    {
      "source": "AMPK: a nutrient and energy sensor that maintains energy homeostasis",
      "target": "076-608-180-638-59X",
      "value": 2
    },
    {
      "source": "AMPK: a nutrient and energy sensor that maintains energy homeostasis",
      "target": "175-263-797-963-040",
      "value": 2
    },
    {
      "source": "AMPK: a nutrient and energy sensor that maintains energy homeostasis",
      "target": "092-197-031-561-353",
      "value": 2
    },
    {
      "source": "Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKKε kinases.",
      "target": "141-694-167-791-759",
      "value": 2
    },
    {
      "source": "Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKKε kinases.",
      "target": "081-203-444-563-604",
      "value": 2
    },
    {
      "source": "Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKKε kinases.",
      "target": "125-348-249-762-351",
      "value": 2
    },
    {
      "source": "Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKKε kinases.",
      "target": "125-850-986-196-787",
      "value": 2
    },
    {
      "source": "Peptide inhibitors of the Keap1-Nrf2 protein-protein interaction",
      "target": "119-397-162-706-860",
      "value": 2
    },
    {
      "source": "Small molecules that bind the Mdm2 RING stabilize and activate p53",
      "target": "133-023-408-974-285",
      "value": 2
    },
    {
      "source": "Small molecules that bind the Mdm2 RING stabilize and activate p53",
      "target": "039-847-299-166-952",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "076-641-402-312-988",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "102-485-198-725-150",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "168-829-456-947-639",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "098-813-369-162-741",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "023-180-369-416-862",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "189-473-046-734-005",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "019-633-684-883-828",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "174-501-376-407-235",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "129-062-448-949-030",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "162-916-741-322-002",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "080-026-305-809-343",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "016-698-167-713-829",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "091-325-080-234-401",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "032-206-614-235-635",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "143-271-017-351-983",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "169-312-245-869-778",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "089-818-979-077-305",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "187-517-157-601-239",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "111-583-988-147-450",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "058-026-435-099-506",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "153-651-762-444-327",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "159-766-711-047-610",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "058-933-099-316-100",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "023-452-662-674-373",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "047-432-030-246-04X",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "139-008-712-602-518",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "137-720-748-139-162",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "192-136-893-476-749",
      "value": 2
    },
    {
      "source": "Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice",
      "target": "172-890-893-515-719",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "104-472-615-006-481",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "097-374-332-908-898",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "034-416-075-094-770",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "127-642-274-375-054",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "036-708-909-192-156",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "193-863-590-855-263",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "150-028-859-997-047",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "034-416-075-094-770",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "097-374-332-908-898",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "104-472-615-006-481",
      "value": 2
    },
    {
      "source": "AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern",
      "target": "132-394-716-226-832",
      "value": 2
    },
    {
      "source": "Changes in the ratio of free NEDD8 to ubiquitin triggers NEDDylation by ubiquitin enzymes",
      "target": "168-483-508-794-377",
      "value": 2
    },
    {
      "source": "Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.",
      "target": "131-238-819-455-784",
      "value": 2
    },
    {
      "source": "Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.",
      "target": "155-402-461-387-483",
      "value": 2
    },
    {
      "source": "Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.",
      "target": "040-389-070-176-191",
      "value": 2
    },
    {
      "source": "Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.",
      "target": "076-478-479-475-120",
      "value": 2
    },
    {
      "source": "A multifunctional protease inhibitor to regulate endolysosomal function.",
      "target": "031-461-589-086-771",
      "value": 2
    },
    {
      "source": "A multifunctional protease inhibitor to regulate endolysosomal function.",
      "target": "190-195-697-065-907",
      "value": 2
    },
    {
      "source": "Design, Synthesis, and Structure−Activity Relationship Exploration of 1-Substituted 4-Aroyl-3-hydroxy-5-phenyl-1H-pyrrol-2(5H)-one Analogues as Inhibitors of the Annexin A2−S100A10 Protein Interaction",
      "target": "034-190-802-321-708",
      "value": 2
    },
    {
      "source": "4-benzimidazolyl-3-phenylbutanoic acids as novel PIF-pocket-targeting allosteric inhibitors of protein kinase PKCζ.",
      "target": "130-316-719-983-242",
      "value": 2
    },
    {
      "source": "Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors",
      "target": "076-478-479-475-120",
      "value": 2
    },
    {
      "source": "Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors",
      "target": "040-389-070-176-191",
      "value": 2
    },
    {
      "source": "Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors",
      "target": "036-668-261-470-040",
      "value": 2
    },
    {
      "source": "Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors",
      "target": "183-767-289-461-131",
      "value": 2
    },
    {
      "source": "Design, Synthesis and Biological Evaluation of Novel Inhibitors of Trypanosoma brucei Pteridine Reductase 1",
      "target": "107-556-164-321-147",
      "value": 2
    },
    {
      "source": "The inhibitory effect of phospholemman on the sodium pump requires its palmitoylation.",
      "target": "106-594-488-484-12X",
      "value": 2
    },
    {
      "source": "SCF/β-TrCP promotes glycogen synthase kinase 3-dependent degradation of the Nrf2 transcription factor in a keap1-independent manner",
      "target": "066-190-726-252-149",
      "value": 2
    },
    {
      "source": "Immunosuppressive but Non-LasR-Inducing Analogues of the Pseudomonas aeruginosa Quorum-Sensing Molecule N-(3-Oxododecanoyl)-L-homoserine Lactone",
      "target": "140-900-012-438-14X",
      "value": 2
    },
    {
      "source": "Absolute SILAC-Compatible Expression Strain Allows Sumo-2 Copy Number Determination in Clinical Samples",
      "target": "058-438-690-312-096",
      "value": 2
    },
    {
      "source": "Absolute SILAC-Compatible Expression Strain Allows Sumo-2 Copy Number Determination in Clinical Samples",
      "target": "004-889-112-130-518",
      "value": 2
    },
    {
      "source": "Collateral sensitivity of multidrug-resistant cells to the orphan drug tiopronin.",
      "target": "193-040-307-473-220",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "188-718-220-131-362",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "087-577-350-425-176",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "191-670-060-004-126",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "188-803-921-043-695",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "041-699-843-843-567",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "180-366-233-781-99X",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "156-653-831-632-101",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "051-324-518-696-462",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "161-487-188-181-03X",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "167-851-091-520-257",
      "value": 2
    },
    {
      "source": "Characterization of a selective inhibitor of the Parkinson's disease kinase LRRK2",
      "target": "122-739-962-072-793",
      "value": 2
    },
    {
      "source": "ATP site-directed inhibitors of protein kinase CK2: an update.",
      "target": "109-274-898-147-341",
      "value": 2
    },
    {
      "source": "Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3",
      "target": "124-179-501-005-870",
      "value": 2
    },
    {
      "source": "Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3",
      "target": "008-694-981-426-172",
      "value": 2
    },
    {
      "source": "Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3",
      "target": "109-611-546-954-080",
      "value": 2
    },
    {
      "source": "Polyubiquitin binding to optineurin is required for optimal activation of TANK-binding kinase 1 and production of interferon β.",
      "target": "004-378-254-734-355",
      "value": 2
    },
    {
      "source": "Polyubiquitin binding to optineurin is required for optimal activation of TANK-binding kinase 1 and production of interferon β.",
      "target": "133-997-520-845-569",
      "value": 2
    },
    {
      "source": "Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.",
      "target": "115-381-943-359-61X",
      "value": 2
    },
    {
      "source": "Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.",
      "target": "022-078-711-389-998",
      "value": 2
    },
    {
      "source": "Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.",
      "target": "132-854-391-972-865",
      "value": 2
    },
    {
      "source": "Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.",
      "target": "171-143-110-884-468",
      "value": 2
    },
    {
      "source": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "target": "003-946-199-636-328",
      "value": 2
    },
    {
      "source": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "target": "009-649-401-227-606",
      "value": 2
    },
    {
      "source": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "target": "170-042-571-881-121",
      "value": 2
    },
    {
      "source": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "target": "033-301-273-471-462",
      "value": 2
    },
    {
      "source": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "target": "040-826-560-477-838",
      "value": 2
    },
    {
      "source": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "target": "048-208-660-423-215",
      "value": 2
    },
    {
      "source": "The cytoprotective role of the Keap1–Nrf2 pathway",
      "target": "135-293-472-746-415",
      "value": 2
    },
    {
      "source": "Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors",
      "target": "153-999-081-812-523",
      "value": 2
    },
    {
      "source": "Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors",
      "target": "000-498-778-953-787",
      "value": 2
    },
    {
      "source": "Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors",
      "target": "085-065-777-135-758",
      "value": 2
    },
    {
      "source": "Analgesic omega-Conotoxins CVIE and CVIF Selectively and Voltage-Dependently Block Recombinant and Native N-Type Calcium Channels (vol 77, pg 139, 2010)",
      "target": "152-366-692-522-975",
      "value": 2
    },
    {
      "source": "Analgesic omega-Conotoxins CVIE and CVIF Selectively and Voltage-Dependently Block Recombinant and Native N-Type Calcium Channels (vol 77, pg 139, 2010)",
      "target": "167-869-142-610-582",
      "value": 2
    },
    {
      "source": "NF-κB controls energy homeostasis and metabolic adaptation by upregulating mitochondrial respiration",
      "target": "191-676-336-200-724",
      "value": 2
    },
    {
      "source": "Development of 18F-fluorinatable dendrons and their application to cancer cell targeting",
      "target": "056-387-403-639-935",
      "value": 2
    },
    {
      "source": "The specificities of small molecule inhibitors of the TGFß and BMP pathways",
      "target": "066-841-401-628-941",
      "value": 2
    },
    {
      "source": "The specificities of small molecule inhibitors of the TGFß and BMP pathways",
      "target": "069-503-782-573-055",
      "value": 2
    },
    {
      "source": "The specificities of small molecule inhibitors of the TGFß and BMP pathways",
      "target": "028-137-796-142-577",
      "value": 2
    },
    {
      "source": "Catalysis by the nucleolytic ribozymes",
      "target": "197-678-301-596-236",
      "value": 2
    },
    {
      "source": "Catalysis by the nucleolytic ribozymes",
      "target": "147-466-934-435-143",
      "value": 2
    },
    {
      "source": "Catalysis by the nucleolytic ribozymes",
      "target": "114-647-123-099-321",
      "value": 2
    },
    {
      "source": "Catalysis by the nucleolytic ribozymes",
      "target": "058-829-130-504-901",
      "value": 2
    },
    {
      "source": "Catalysis by the nucleolytic ribozymes",
      "target": "169-953-034-717-264",
      "value": 2
    },
    {
      "source": "Characterization of GSK2334470, a novel and highly specific inhibitor of PDK1",
      "target": "028-012-588-449-727",
      "value": 2
    },
    {
      "source": "Characterization of GSK2334470, a novel and highly specific inhibitor of PDK1",
      "target": "038-839-140-589-623",
      "value": 2
    },
    {
      "source": "N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases",
      "target": "194-924-906-201-593",
      "value": 2
    },
    {
      "source": "N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases",
      "target": "195-611-964-620-410",
      "value": 2
    },
    {
      "source": "N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases",
      "target": "025-014-524-538-421",
      "value": 2
    },
    {
      "source": "N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases",
      "target": "025-014-524-538-421",
      "value": 2
    },
    {
      "source": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "target": "120-667-268-642-909",
      "value": 2
    },
    {
      "source": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "target": "163-117-320-460-138",
      "value": 2
    },
    {
      "source": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "target": "191-290-593-697-506",
      "value": 2
    },
    {
      "source": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "target": "118-339-847-530-982",
      "value": 2
    },
    {
      "source": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "target": "073-318-370-112-877",
      "value": 2
    },
    {
      "source": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "target": "113-828-920-381-078",
      "value": 2
    },
    {
      "source": "AMP-activated protein kinase—an energy sensor that regulates all aspects of cell function",
      "target": "048-983-957-537-421",
      "value": 2
    },
    {
      "source": "Optimisation of the Anti-Trypanosoma brucei Activity of the Opioid Agonist U50488",
      "target": "073-531-962-083-670",
      "value": 2
    }
  ]
}
